import { render } from "./SchedulesDetail.vue?vue&type=template&id=ed40e982"
import script from "./SchedulesDetail.vue?vue&type=script&lang=js"
export * from "./SchedulesDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__